import React, { Component } from 'react'
import { connect } from 'react-redux'

import LeftNavMenu from './LeftNavMenu'
import { route } from 'selectors/common'

let select = (state) => ({
	screenSize: state.screenSize
  , route: route(state)
})

let widthOfColumns = (widthOfScreen, count, detailID) => {
	if (widthOfScreen <= 900 && detailID){
		return{menu: 0, left: 0, list: 0, right: widthOfScreen, count:1}
	}
	if (widthOfScreen > 800 && widthOfScreen <= 1300) count=1
	if (!detailID) count=0
	let menu = 55
	let left = widthOfScreen/(count+1)
	if (count == 1 && widthOfScreen > 1100) left = widthOfScreen - (widthOfScreen*1/3>500?widthOfScreen*1/3:500)
	let list = left-menu
	let right = widthOfScreen-left
	return{menu, left, list, right, count}
}

export class MasterDetailLayout extends Component {
	render() {
		let { props } = this
		let width = widthOfColumns(props.screenSize, props.detailColumns, props.detailOpen)
		return(
			<div className="layout horizontal">
				{width.left>0 && <div className="layout vertical" style={{width:width.left+"px"}}>
					{props.header({width: "100%"})}
					<div className="layout horizontal">
						<LeftNavMenu style={{width:width.menu+"px"}} route={props.route} />
						{width.list && props.master({width:width.list, masterDetail: props.detailOpen, detailID: props.detailID})}
					</div>
				</div>}
				{props.detailOpen &&
					<div style={{width:width.right+"px", margin: "0", boxShadow: "rgba(0, 0, 0, 0.156863) 0px 3px 10px, rgba(0, 0, 0, 0.227451) 0px 3px 10px", position: "relative"}}>
					 	{props.detail({width:width.right+"px", colspan: width.count, masterDetail: (width.list>0)})}
					</div>
				}
			</div>
		)
	}
}

export default connect(select)(MasterDetailLayout)



// WEBPACK FOOTER //
// ./src/components/MasterDetailLayout.js